import { Helmet, HelmetProvider } from 'react-helmet-async';
import { useRealmStore } from '../../utils/realmStore';

const helmetContext = {};

type MetaProps = {
  title: string;
  description?: string;
};
const Meta = (props: MetaProps) => {
  const isPTR = useRealmStore((state) => state.isPTR);

  const contentTitle = `${props.title}${
    isPTR ? ' - Public Test Realm' : ''
  } - New World Map - aeternum-map.th.gl`;
  const contentDescription = `${
    props.description ? ` ${props.description} ` : ''
  }Maximize your New World gameplay with Aeternum Map${
    isPTR ? ' on Public Test Realm (PTR)' : ''
  }! Discover locations, chests, lore, expeditions & more. Realtime tracking & farming routes. Free in your browser and as an in-game overlay.`;

  const url = location.origin + location.pathname;
  return (
    <HelmetProvider context={helmetContext}>
      <Helmet prioritizeSeoTags>
        <link rel="canonical" href={url} />

        <title>{contentTitle}</title>
        <meta name="description" content={contentDescription} />

        <meta property="og:type" content="website" />
        <meta property="og:url" content={url} />
        <meta property="og:title" content={contentTitle} />
        <meta property="og:description" content={contentDescription} />

        <meta property="twitter:card" content="summary" />
        <meta property="twitter:url" content={url} />
        <meta property="twitter:title" content={contentTitle} />
        <meta property="twitter:description" content={contentDescription} />
      </Helmet>
    </HelmetProvider>
  );
};

export default Meta;
